<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-link"></i> Lưu kho'

             title="Thêm mới cấu hình kho"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model="model.shopName" disabled="" label="Shop" validate-rules="required"/>
      <c-input v-model="model.name" disabled="" label="Kho" validate-rules="required"/>

      <c-input v-model.trim="model.tel"
               label="Số điện thoại kho"
      />

      <c-input v-model.trim="model.first_address"
               label="Địa chỉ kho người dùng cung cấp"
      />

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "warehouse-add-quick",
  mixins: [dialogMixins],
  data: function () {
    return {
      model: {
        shop_order: null,
        station_id: null,
        first_address: null,
        tel: null
      },
    }
  },
  methods: {
    open(item){
      this.model = {
        shopName: `${item.shopCode} - ${item.shopName}`,
        name: item.name,
        shop_order: item.shopOrder,
        station_id: item.stationId,
        first_address: null,
        tel: null
      }
      this.show = true;
    },
    resetForm() {
      this.model = {
        shop_order: null,
        station_id: null,
        first_address: null,
        tel: null
      }
    },
    submit() {
      this.$showLoader();
      let data = {
        "first_address": this.model.first_address,
        "station_id": this.model.station_id,
        "tel": this.model.tel
      }
      this.$http
          .post("/admin-service/v1.0/station/warehouse-shop?shop_order=" + this.model.shop_order, data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes))
            ;
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>